export default __webpack_public_path__ + "static/media/Emerald Teeth Necklace.73ce566c.jpg";